import apiClient from './client'

export const searchApi = {
  getUniversities: async () => {
    const response = await apiClient.get('/universities')
    return response.data
  },

  getFaculties: async (id) => {
    const response = await apiClient.get(`/faculties/${id}`)
    return response.data
  },

  getColleges: async (universityId) => {
    // API uses 'faculties' endpoint
    const response = await apiClient.get(`/faculties/${universityId}`)
    return response.data
  },

  getFaculties: async (universityId) => {
    const response = await apiClient.get(`/faculties/${universityId}`)
    return response.data
  },

  getDepartments: async (collegeId, universityBandId = null) => {
    const params = universityBandId ? { university_band_id: universityBandId } : {}
    const response = await apiClient.get(`/departments/${collegeId}`, { params })
    return response.data
  },

  getSpecializations: async (departmentId) => {
    const response = await apiClient.get(`/specializations/${departmentId}`)
    return response.data
  },

  getSemesters: async (universityId) => {
    const response = await apiClient.get('/semesters', {
      params: { university_id: universityId }
    })
    return response.data
  },

  getUniversityBands: async (collegeId) => {
    const response = await apiClient.get('/university-bands', {
      params: { faculty_id: collegeId }
    })
    return response.data
  },

  getTerms: async (id) => {
    const response = await apiClient.get(`/terms/${id}`)
    return response.data
  },

  getSubjects: async (id) => {
    const response = await apiClient.get(`/subjects/${id}`)
    return response.data
  },
}

